import {
  AssembleiasAssociadoActionTypes,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS,
  ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA,
  ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DEMAIS_ASSEMBLEIAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DEMAIS_ASSEMBLEIAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_TOTAL_CONVOCACOES,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_TOTAL_CONVOCACOES,
} from './AssembleiasAssociadoActionTypes';
import { ListaPerguntas } from 'api/Associado/duvidas';
import { AssembleiaStatus } from 'enuns/AssembleiaStatus';
import { AssembleiaPautaStatus } from 'enuns/AssembleiaPautaStatus';
import { IWSAssembleia } from './WSAssembleiasReducer';
import { WS_ASSEMBLEIAS_ACTIONS_OPEN, WSAssembleiasActionTypes } from './WSAssembleiasActionTypes';
import { AUTH_ACTIONS_LOGOUT, IAuthActionsLogout } from './AuthActionTypes';
import { TipoCargosChapa } from 'enuns/TipoCargosChapa';
import { TipoPauta } from 'enuns/TipoPauta';
import { AssembleiaResponse } from 'api/Associado/evento';
import { AssembleiaContaAssociado } from 'models/AssembleiaContaAssociado';
import { AssembleiasConvocado } from 'api/Associado/convocado';

export interface IAssembleiaContasAssociado {
  assembleiaId: number;
  contas: AssembleiaContaAssociado[];
}

type DateJSON = string;

export interface IAssembleiaAssociado {
  id: number;
  nome: string;
  descricao?: string;
  tipo: string;
  status: AssembleiaStatus;
  dataEvento: DateJSON;
  dataEventoFim: DateJSON;
}

export interface IAAssociadoEventoDocumento {
  desDocumento: string;
  nomDocumento: string;
  oidDocumento: number;
  tipoDocumento: string;
}

export interface IAAssociadoEventVideo {
  descricao: string;
  oidVideo: number;
  urlYoutube: string;
}

export interface IAssembleiaAssociadoPautaOpcao {
  descricao: string;
  flgAbstencao: boolean;
  idItemPauta: number;
  representantesChapa: IRepresentantesChapa[];
  ordem: number;
}

export interface IRepresentantesChapa {
  associado: string,
  idCargo: 0,
  idRepresentanteChapa: 0,
  nomeCargo: TipoCargosChapa
}

export interface IAssembleiaAssociadoPautaVoto {
  cpfRepresentante: string;
  data: string;
  id: number;
  idConvocado: number;
  idEvento: number;
  idItemPauta: number;
  idPauta: number;
  tipo: number;
}

export interface IAssembleiaAssociadoPauta {
  codigoAgencia: string;
  titulo: string;
  descricao: string;
  idPauta: number;
  itens: IAssembleiaAssociadoPautaOpcao[];
  flgResultadoLiberado: boolean;
  numeroNucleo: string;
  ordem: number;
  status: AssembleiaPautaStatus;
  tempoVotacao: number;
  tempoRestante: number,
  tipoPauta: TipoPauta;
  idsProdutos: number[],
  votos: IAssembleiaAssociadoPautaVoto[];
}

export interface IAssembleiaAssociadoEvento extends AssembleiaResponse {
  dataBloqueio: DateJSON;
  dataCadastro: DateJSON;
  contasDisponiveis?: AssembleiaContaAssociado[];
  pautas?: IAssembleiaAssociadoPauta[];
  presentes: number;
  usuariosLogados: number;
  refreshedTimes: number;
  needLoadAssembleia: boolean,
  needLoadPautas: boolean,
  needLoadContas: boolean,
}

export interface IAssembleiasAssociadoDuvidas {
  usuario: ListaPerguntas;
  publica: ListaPerguntas;
}

export interface IAssembleiasAssociadoReducer {
  loadingAll: boolean;
  all: IAssembleiaAssociado[];
  loadingDemaisAssembleias: boolean;
  demaisAssembleias: IAssembleiaAssociado[];
  needLoadAll: boolean;
  loadingEvent: boolean;
  currentEvent: IAssembleiaAssociadoEvento | null;
  downloadindDocument: number[];
  downloadSuccessfully: number[];
  loadingContas: boolean;
  loadingPautas: boolean;
  consultaByCpfCnpj: AssembleiasConvocado;
  loadingConsultaByCpfCnpj: boolean;
  loadingDuvidas: boolean;
  duvidas: IAssembleiasAssociadoDuvidas | null;
  loadingRespostaPauta: boolean,
  respostaPauta: IAssembleiaAssociadoRespostaPauta | null;
  loadingTotalConvocacoes: boolean;
  totalConvocacoes: number;
}

export interface IAssembleiaConsultaByCpfCnpj {
  bairro: string;
  cep: string;
  cidade: string;
  codigoAgencia: string;
  codigoCooperativa: string;
  dataEvento: DateJSON;
  descricao: string;
  endereco: string;
  estado: string;
  modeloEvento: number;
  nomeCooperativa: string,
  nucleo: string;
  titulo: string;
}

export interface IAssembleiaAssociadoRespostaPauta {
  agencias: IRespostaPautaAgencias[],
  descricao: string,
  idPauta: number,
  titulo: string
}

export interface IRespostaPautaAgencias {
  codigoAgencia: string,
  nucleos: IRespostaPautaAgenciasNucleos[]
}

export interface IRespostaPautaAgenciasNucleos {
  itens: IRespostaPautaAgenciaNucleosItens[],
  numeroNucleo: string,
  presentes: number
}

export interface IRespostaPautaAgenciaNucleosItens {
  abstencao: true,
  descricao: string,
  idItemPauta: number,
  percentual: number,
  votos: number
}

const INITIAL_STATE: IAssembleiasAssociadoReducer = {
  loadingAll: false,
  all: [],
  loadingDemaisAssembleias: false,
  demaisAssembleias: [],
  needLoadAll: true,
  loadingEvent: false,
  currentEvent: null,
  downloadindDocument: [],
  downloadSuccessfully: [],
  loadingContas: false,
  loadingPautas: false,
  consultaByCpfCnpj: [],
  loadingConsultaByCpfCnpj: false,
  loadingDuvidas: false,
  duvidas: null,
  loadingRespostaPauta: false,
  respostaPauta: null,
  loadingTotalConvocacoes: false,
  totalConvocacoes: 0,
};

const getAssembleiaEventoComPautas = (
  state: IAssembleiasAssociadoReducer,
  assembleiaId: number,
  pautasPorAssembleia: IAssembleiaAssociadoPauta[]
): IAssembleiaAssociadoEvento | null => {
  if (state.currentEvent?.idAssembleia === assembleiaId) {
    state.currentEvent.pautas = pautasPorAssembleia;
    state.currentEvent.refreshedTimes = state.currentEvent.refreshedTimes + 1;
    return state.currentEvent;
  }
  return null;
};

const getAssembleiaEventoComContas = (
  state: IAssembleiasAssociadoReducer,
  contasPorAssembleia: IAssembleiaContasAssociado
): IAssembleiaAssociadoEvento | null => {
  if (
    state.currentEvent?.idAssembleia === contasPorAssembleia.assembleiaId
  ) {
    state.currentEvent.contasDisponiveis = contasPorAssembleia.contas;
    state.currentEvent.refreshedTimes = state.currentEvent.refreshedTimes + 1;
    return state.currentEvent;
  }
  return null;
};

const getRefreshedState = (state: IAssembleiasAssociadoReducer, assembleia: IWSAssembleia):IAssembleiasAssociadoReducer => {
  const newState: IAssembleiasAssociadoReducer = { ...state };
  newState.needLoadAll = typeof assembleia.needLoadList === 'boolean' ? assembleia.needLoadList : newState.needLoadAll;
  if (
    newState.currentEvent &&
    (newState.currentEvent.idAssembleia === assembleia.id ||
    newState.currentEvent.idAssembleia === assembleia.idPauta)
  ) {
    newState.currentEvent = {
      ...newState.currentEvent,
      refreshedTimes: newState.currentEvent.refreshedTimes + 1,
      presentes: typeof assembleia.presentes === 'number' ? assembleia.presentes : newState.currentEvent.presentes,
      usuariosLogados: typeof assembleia.usuariosLogados === 'number' ? assembleia.usuariosLogados : newState.currentEvent.usuariosLogados,
      status: typeof assembleia.status === 'number' ? assembleia.status : newState.currentEvent.status,
      needLoadAssembleia: typeof assembleia.needLoadAssembleia === 'boolean' ? assembleia.needLoadAssembleia : false,
      needLoadPautas: typeof assembleia.needLoadPautas === 'boolean' ? assembleia.needLoadPautas : false,
      needLoadContas: typeof assembleia.needLoadContas === 'boolean' ? assembleia.needLoadContas : false,
      statusChat: typeof assembleia.isChatAtivo === 'boolean' ? assembleia.isChatAtivo : newState.currentEvent.statusChat,
      pautas: newState.currentEvent.pautas
        ? newState.currentEvent.pautas.map((pauta) => {
          const filteredRefreshedPautas = assembleia.pautas ? assembleia.pautas.filter((pautaRefreshed) => pautaRefreshed.idPauta === pauta.idPauta) : [];
          if (filteredRefreshedPautas.length > 0) {
            const tempoRestante: number = filteredRefreshedPautas[0].tempoRestante || 0;
            let status: AssembleiaPautaStatus = typeof filteredRefreshedPautas[0].status === 'number' ? filteredRefreshedPautas[0].status : pauta.status;
            if (!tempoRestante && status === AssembleiaPautaStatus.Liberada) {
              status = AssembleiaPautaStatus.Encerrada;
            }
            return {
              ...pauta,
              status: status,
              tempoRestante: tempoRestante,
              tempoVotacao: filteredRefreshedPautas[0].tempoVotacao,
              flgResultadoLiberado: filteredRefreshedPautas[0].flgResultadoLiberado !== null ? filteredRefreshedPautas[0].flgResultadoLiberado : pauta.flgResultadoLiberado
            }
          }
          return pauta;
        })
        : []
    };
  }
  if (newState.all && newState.all.length > 0) {
    newState.all = newState.all.map((evento) => {
      if (evento.id === assembleia.id || evento.id === assembleia.idPauta) {
        return {
          ...evento,
          status: typeof assembleia.status === 'number' ? assembleia.status : evento.status
        }
      }
      return evento;
    })
  }
  return newState;
}

const getContasComPresenca = (
  state: IAssembleiasAssociadoReducer,
  cpfCnpj: string,
  idsConvocados: number[],
  assembleiaId: number,
): IAssembleiaContasAssociado => {
  let contas = [ ...(state.currentEvent && state.currentEvent.contasDisponiveis ? state.currentEvent.contasDisponiveis : []) ];
  contas = contas.map((conta: AssembleiaContaAssociado): AssembleiaContaAssociado => {
    const presente: boolean = !conta.presente && idsConvocados.indexOf(conta.idConvocado) > -1;
    return {
      ...conta,
      cpfRepresentanteConfirmado: !conta.presente ? cpfCnpj : conta.cpfRepresentanteConfirmado,
      presente: !conta.presente ? presente : conta.presente,
    }
  })
  return {
    assembleiaId: assembleiaId,
    contas: contas
  }
}

export default (
  state: IAssembleiasAssociadoReducer = INITIAL_STATE,
  action: AssembleiasAssociadoActionTypes | WSAssembleiasActionTypes | IAuthActionsLogout
) => {
  switch (action.type) {
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA:
      const eventoComContasPresentes: IAssembleiaAssociadoEvento | null = getAssembleiaEventoComContas(
        state,
        getContasComPresenca(
          state,
          action.payload.cpfCnpj,
          action.payload.idsConvocados,
          action.payload.assembleiaId,
        )
      );
      if (eventoComContasPresentes) {
        return { ...state, currentEvent: eventoComContasPresentes };
      }
      return state;
    case WS_ASSEMBLEIAS_ACTIONS_OPEN:
      return {
        ...state,
        needLoadAll: true,
        currentEvent: (
          state.currentEvent ?
            {
              ...state.currentEvent,
              needLoadAssembleia: true
            } :
          state.currentEvent
        )
      }
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH:
      return getRefreshedState(state, action.payload);
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS:
      return { ...state, loadingPautas: action.payload, currentEvent: { ...state.currentEvent, needLoadPautas: false } };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS:
      const eventoComPautas: IAssembleiaAssociadoEvento | null = getAssembleiaEventoComPautas(
        state,
        action.assembleiaId,
        action.payload
      );
      if (eventoComPautas) {
        return { ...state, currentEvent: eventoComPautas };
      }
      return state;
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS:
      return { ...state, loadingContas: action.payload, currentEvent: { ...state.currentEvent, needLoadContas: false } };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS:
      const eventoComContas: IAssembleiaAssociadoEvento | null = getAssembleiaEventoComContas(
        state,
        action.payload
      );
      if (eventoComContas) {
        return { ...state, currentEvent: eventoComContas };
      }
      return state;
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL:
      return { ...state, loadingAll: action.payload, needLoadAll: false };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL:
      return { ...state, all: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DEMAIS_ASSEMBLEIAS:
      return { ...state, loadingDemaisAssembleias: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DEMAIS_ASSEMBLEIAS:
      return { ...state, demaisAssembleias: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT:
      return { ...state, currentEvent: null, totalConvocacoes: 0, loadingTotalConvocacoes: false };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT:
      return {
        ...state,
        loadingEvent: action.payload,
        currentEvent: {
          ...state.currentEvent,
          needLoadAssembleia: false
        }
      };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT:
      return {
        ...state,
        currentEvent: {
          ...state.currentEvent,
          ...action.payload,
          refreshedTimes: 0,
          needLoadContas: true,
          needLoadPautas: true,
          needLoadAssembleia: false,
        }
      };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE:
      return { ...state, downloadindDocument: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS:
      return { ...state, downloadSuccessfully: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ:
      return { ...state, loadingConsultaByCpfCnpj: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ:
      return { ...state, consultaByCpfCnpj: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS:
      return { ...state, loadingDuvidas: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS:
      return { ...state, duvidas: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA:
      return { ...state, loadingRespostaPauta: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA:
      return { ...state, respostaPauta: action.payload }
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO:
      return {
        ...state,
        currentEvent: {
          ...(state.currentEvent || {}),
          needLoadPautas: true
        }
      }
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_TOTAL_CONVOCACOES:
      return { ...state, loadingTotalConvocacoes: action.payload }
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_TOTAL_CONVOCACOES:
      return { ...state, totalConvocacoes: action.payload }
    case AUTH_ACTIONS_LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};
